import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { isAutoServicesTenant } from "../../../utils/tenantBranding";
 
// Set the app element for accessibility
Modal.setAppElement("#root");
 
interface TermsAndConditionsModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  onAccept: () => void;
}
 
const TermsAndConditionsModalComponent: React.FC<
  TermsAndConditionsModalProps
> = ({ isOpen, onRequestClose, onAccept }) => {
  const [acceptTerms, setAcceptTerms] = useState<boolean>(false);
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
 
  useEffect(() => {
    if (isOpen) {
      setAcceptTerms(false);
      setIsProcessing(false);
    }
  }, [isOpen]);
 
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    setAcceptTerms(isChecked);
 
    if (isChecked) {
      setIsProcessing(true);
      onAccept();
 
      setTimeout(() => {
        setIsProcessing(false);
        onRequestClose();
      }, 2000);
    }
  };
 
  const handleClose = () => {
    onRequestClose();
  };
 
  const fetchingTenant = window.location.hostname.split(".")[0];
   
  const autoServicesBranding = isAutoServicesTenant(fetchingTenant);
  const legalBrandName = autoServicesBranding
    ? "Auto Services"
    : "EUROREPAR CAR SERVICE";
  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={handleClose}
        contentLabel="Terms and Conditions"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1000,
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "600px",
            maxHeight: "80vh",
            padding: "0",
            borderRadius: "8px",
            border: "none",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
          },
        }}
      >
        <div
          style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#fff",
            borderRadius: "8px",
          }}
        >
          {/* Header */}
          <div
            style={{
              padding: "20px",
              borderBottom: "1px solid #e0e0e0",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "#f8f9fa",
              borderRadius: "8px 8px 0 0",
            }}
          >
            <h2 style={{ margin: 0, color: "#333", fontSize: "24px" }}>
              Terms and Conditions
            </h2>
            <button
              onClick={handleClose}
              style={{
                background: "none",
                border: "none",
                fontSize: "24px",
                cursor: "pointer",
                color: "#666",
                padding: "0",
                width: "30px",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              ×
            </button>
          </div>
 
          {/* Scrollable Content */}
          <div
            style={{
              flex: 1,
              padding: "20px",
              overflowY: "auto",
              lineHeight: "1.6",
              color: "#333",
            }}
          >
            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ color: "#007bff", marginBottom: "10px" }}>
                1. Acceptance of Terms
              </h3>
              <p>
                By accessing and using {legalBrandName}, you accept and
                agree to be bound by the terms and provision of this agreement.
              </p>
            </div>
 
            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ color: "#007bff", marginBottom: "10px" }}>
                2. Service Description
              </h3>
              <p>
                {legalBrandName} provides automotive repair and maintenance
                services. We strive to deliver high-quality service and customer
                satisfaction.
              </p>
            </div>
 
            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ color: "#007bff", marginBottom: "10px" }}>
                3. User Responsibilities
              </h3>
              <p>
                Users are responsible for providing accurate information when
                booking services and maintaining the security of their account
                credentials.
              </p>
            </div>
 
            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ color: "#007bff", marginBottom: "10px" }}>
                4. Privacy Policy
              </h3>
              <p>
                We respect your privacy and are committed to protecting your
                personal information. Your data will be handled in accordance
                with our privacy policy.
              </p>
            </div>
 
            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ color: "#007bff", marginBottom: "10px" }}>
                5. Service Limitations
              </h3>
              <p>
                While we strive to provide excellent service, we cannot
                guarantee that our services will be uninterrupted or error-free.
                Service availability may vary.
              </p>
            </div>
 
            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ color: "#007bff", marginBottom: "10px" }}>
                6. Payment Terms
              </h3>
              <p>
                Payment for services is due upon completion unless otherwise
                arranged. We accept various payment methods as displayed during
                the booking process.
              </p>
            </div>
 
            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ color: "#007bff", marginBottom: "10px" }}>
                7. Cancellation Policy
              </h3>
              <p>
                Service cancellations must be made at least 24 hours in advance.
                Cancellations made with less notice may be subject to
                cancellation fees.
              </p>
            </div>
 
            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ color: "#007bff", marginBottom: "10px" }}>
                8. Liability Limitations
              </h3>
              <p>
                Our liability is limited to the cost of the service provided. We
                are not responsible for indirect, incidental, or consequential
                damages.
              </p>
            </div>
 
            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ color: "#007bff", marginBottom: "10px" }}>
                9. Modifications to Terms
              </h3>
              <p>
                We reserve the right to modify these terms at any time. Users
                will be notified of significant changes, and continued use
                constitutes acceptance of modified terms.
              </p>
            </div>
 
            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ color: "#007bff", marginBottom: "10px" }}>
                10. Contact Information
              </h3>
              <p>
                For questions about these terms and conditions, please contact
                us through our customer service channels available on our
                website.
              </p>
            </div>
 
  
          </div>
        </div>
      </Modal>
 
      {/* 🔄 Moved outside jsx */}
      <style>
        {`
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </>
  );
};
 
export default TermsAndConditionsModalComponent;
 
 